const processAction = (state, action) => {
  switch (action.type) {
    case 'showLauncher':
    case 'showMenu':
    case 'showWidget':
      return { ...state, [action.type]: action.payload };
    default:
      throw new Error(`${action.type} is not found!`);
  }
};

export default (state, actions) => {
  if (Array.isArray(actions)) {
    actions.forEach((action) => {
      state = processAction(state, action);
    });
  } else {
    state = processAction(state, actions);
  }
  return state;
};
